import * as types from '../actionTypes/lobbyist'

export function getLobbyists(lobbyists) {
  return {
    type: types.GET_LOBBYISTS,
    lobbyists
  }
}

export function getLobbyistListItems(lobbyistListItems) {
  return {
    type: types.GET_LOBBYIST_LIST_ITEMS,
    lobbyistListItems
  }
}

export function getLobbyist(lobbyist) {
  return {
    type: types.GET_LOBBYIST,
    lobbyist
  }
}

export function getChangesRequired(changesRequired) {
  return {
    type: types.GET_CHANGES_REQUIRED,
    changesRequired
  }
}

export function addActiveLobbyistGridIndex(index) {
  return {
    type: types.ADD_ACTIVE_LOBBYIST_GRID_INDEX,
    index
  }
}

export function removeActiveLobbyistGridIndex(index) {
  return {
    type: types.REMOVE_ACTIVE_LOBBYIST_GRID_INDEX,
    index
  }
}



// WEBPACK FOOTER //
// ./src/actions/lobbyist.js